import React, { Component } from 'react'
import PropTypes from 'prop-types'
import './Logo.css'

export default class Logo extends Component {
  static propTypes = {
    onClick: PropTypes.func,
    someProp: PropTypes.string,
  }
  static defaultProps = {
    someProp: 'someValue',
  }

  constructor(props) {
    super(props)
    this.state = {
      someState: true,
    }
  }

  render() {
    return (
      <svg className={this.props.containerClass} viewBox="0 0 352.53 358.05">
        <title>logo</title>
        <g>
          <path
            d="M322.06,361.52H201.78v-12H322.06a24,24,0,0,0,24-24v-286a24,24,0,0,0-24-24H201.78v-12H322.06a36,36,0,0,1,36,36v286A36,36,0,0,1,322.06,361.52Z"
            transform="translate(-5.53 -3.47)"
          />
          <path
            d="M278.06,21.62"
            transform="translate(-5.53 -3.47)"
            fill="none"
            strokeMiterlimit="10"
            strokeWidth="8"
          />
          <path
            d="M278.12,344"
            transform="translate(-5.53 -3.47)"
            fill="none"
            stroke="#000"
            strokeMiterlimit="10"
            strokeWidth="8"
          />
          <path
            d="M243.25,361.51H56V3.51H243.25c22.53,0,40.92,15.73,41,35.06V326.34C284.24,345.73,265.85,361.51,243.25,361.51ZM68,349.51H243.25c16,0,29-10.39,29-23.17V38.59c-.05-12.72-13.05-23.08-29-23.08H68Z"
            transform="translate(-5.53 -3.47)"
          />
          <path
            d="M67.87,361.47H56.8a40,40,0,0,1-39.93-39.89V43.41A40,40,0,0,1,56.81,3.47H67.87Zm-39-39.91a28,28,0,0,0,27,27.89v-334a28,28,0,0,0-27,27.92V321.57Z"
            transform="translate(-5.53 -3.47)"
          />
          <g>
            <circle cx="34.09" cy="296.26" r="11.84" />
            <circle cx="34.09" cy="250.07" r="11.84" />
            <circle cx="34.09" cy="203.88" r="11.84" />
            <circle cx="34.09" cy="157.69" r="11.84" />
            <circle cx="34.09" cy="111.49" r="11.84" />
            <circle cx="34.09" cy="65.3" r="11.84" />
          </g>
          <g>
            <rect
              x="0.5"
              y="290.3"
              width="27.44"
              height="11.93"
              rx="4.5"
              ry="4.5"
            />
            <path
              d="M29,306.2H10.53a5,5,0,0,1-5-5v-2.93a5,5,0,0,1,5-5H29a5,5,0,0,1,5,5v2.93A5,5,0,0,1,29,306.2ZM10.53,294.27a4,4,0,0,0-4,4v2.93a4,4,0,0,0,4,4H29a4,4,0,0,0,4-4v-2.93a4,4,0,0,0-4-4Z"
              transform="translate(-5.53 -3.47)"
            />
          </g>
          <g>
            <rect
              x="0.5"
              y="244.1"
              width="27.44"
              height="11.93"
              rx="4.5"
              ry="4.5"
            />
            <path
              d="M29,260H10.53a5,5,0,0,1-5-5v-2.93a5,5,0,0,1,5-5H29a5,5,0,0,1,5,5V255A5,5,0,0,1,29,260ZM10.53,248.07a4,4,0,0,0-4,4V255a4,4,0,0,0,4,4H29a4,4,0,0,0,4-4v-2.93a4,4,0,0,0-4-4Z"
              transform="translate(-5.53 -3.47)"
            />
          </g>
          <g>
            <rect
              x="0.5"
              y="197.91"
              width="27.44"
              height="11.93"
              rx="4.5"
              ry="4.5"
            />
            <path
              d="M29,213.81H10.53a5,5,0,0,1-5-5v-2.93a5,5,0,0,1,5-5H29a5,5,0,0,1,5,5v2.93A5,5,0,0,1,29,213.81ZM10.53,201.88a4,4,0,0,0-4,4v2.93a4,4,0,0,0,4,4H29a4,4,0,0,0,4-4v-2.93a4,4,0,0,0-4-4Z"
              transform="translate(-5.53 -3.47)"
            />
          </g>
          <g>
            <rect
              x="0.5"
              y="151.72"
              width="27.44"
              height="11.93"
              rx="4.5"
              ry="4.5"
            />
            <path
              d="M29,167.62H10.53a5,5,0,0,1-5-5v-2.93a5,5,0,0,1,5-5H29a5,5,0,0,1,5,5v2.93A5,5,0,0,1,29,167.62ZM10.53,155.69a4,4,0,0,0-4,4v2.93a4,4,0,0,0,4,4H29a4,4,0,0,0,4-4v-2.93a4,4,0,0,0-4-4Z"
              transform="translate(-5.53 -3.47)"
            />
          </g>
          <g>
            <rect
              x="0.5"
              y="105.53"
              width="27.44"
              height="11.93"
              rx="4.5"
              ry="4.5"
            />
            <path
              d="M29,121.43H10.53a5,5,0,0,1-5-5V113.5a5,5,0,0,1,5-5H29a5,5,0,0,1,5,5v2.93A5,5,0,0,1,29,121.43ZM10.53,109.5a4,4,0,0,0-4,4v2.93a4,4,0,0,0,4,4H29a4,4,0,0,0,4-4V113.5a4,4,0,0,0-4-4Z"
              transform="translate(-5.53 -3.47)"
            />
          </g>
          <g>
            <rect
              x="0.5"
              y="59.33"
              width="27.44"
              height="11.93"
              rx="4.5"
              ry="4.5"
            />
            <path
              d="M29,75.23H10.53a5,5,0,0,1-5-5V67.3a5,5,0,0,1,5-5H29a5,5,0,0,1,5,5v2.93A5,5,0,0,1,29,75.23ZM10.53,63.3a4,4,0,0,0-4,4v2.93a4,4,0,0,0,4,4H29a4,4,0,0,0,4-4V67.3a4,4,0,0,0-4-4Z"
              transform="translate(-5.53 -3.47)"
            />
          </g>
          <path
            d="M296.4,254.83h2.47V345.4H296.4Zm15.44-108h2.47V344.61h-2.47Zm16.06,10.68h-2.47V26.21L327.9,28Zm-2.47,58.71h2.47v45.59h-2.47Zm-13.59-163h2.47V98.84h-2.47Z"
            transform="translate(-5.53 -3.47)"
          />
          <path
            d="M129,195a5,5,0,0,1-3.54-1.46L102.9,171a5,5,0,0,1,0-7.07l22.51-22.51a5,5,0,0,1,7.07,7.07l-19,19,19,19a5,5,0,0,1-3.54,8.54Zm64.82,0a5,5,0,0,1-3.54-8.54l19-19-19-19a5,5,0,0,1,7.07-7.07l22.51,22.51a5,5,0,0,1,0,7.07L197.3,193.48a5,5,0,0,1-3.53,1.52Zm-41.58,14.87a5,5,0,0,1-4.84-6.27l19.72-74.85a5,5,0,0,1,9.67,2.55L157,206.14a5,5,0,0,1-4.81,3.73Z"
            transform="translate(-5.53 -3.47)"
          />
        </g>
      </svg>
    )
  }
}



// WEBPACK FOOTER //
// ./src/common/logo/Logo.js